module.exports = {
  'ja': require('./japanese'),
  'en': require('./english')
}
